import React from 'react';

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[WatchVIM V3] Unhandled render error', error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  handleHome = () => {
    window.location.assign('/home');
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="app-error" role="alert">
        <div className="app-error-card">
          <p className="eyebrow">WatchVIM</p>
          <h1>This section could not load.</h1>
          <p>The rest of WatchVIM is still available. Retry this screen or return Home.</p>
          <div className="app-error-actions">
            <button type="button" onClick={this.handleRetry}>Retry</button>
            <button type="button" className="secondary" onClick={this.handleHome}>Go Home</button>
          </div>
        </div>
      </main>
    );
  }
}
